<template>
  <div class="w-full h-2/5">
    <!-- 地图操作集合 -->
    <div class="text-12px h-full">
      <div class="flex items-center mt-10px">
        <span class="text-white w-60px">小地图</span>
        <el-switch
          v-model="openMapSwitch"
          active-color="#13ce66"
          inactive-color="#ff4949"
        ></el-switch>
      </div>
      <div class="flex items-center mt-10px">
        <div class="text-12px text-white w-60px">地图大小</div>
        <el-input-number
          size="mini"
          v-model="wMap"
          class="w-110px"
          @change="MapChange('x', arguments)"
          :min="0.01"
          :max="500"
          placeholder="宽"
        ></el-input-number>
        <el-input-number
          size="mini"
          class="w-110px"
          v-model="hMap"
          @change="MapChange('y', arguments)"
          :min="0.01"
          :max="500"
          placeholder="高"
        ></el-input-number>
      </div>
      <div class="flex items-center mt-10px">
        <div class="text-12px text-white w-60px">地图缩放</div>
        <el-input-number
          size="mini"
          v-model="wParam"
          @change="widthChange"
          :min="0.01"
          :max="100"
          :step="0.02"
          placeholder="比例"
        ></el-input-number>
      </div>
      <div class="flex items-center mt-10px">
        <span class="text-12px text-white w-60px">视角方向</span>
        <el-select
          size="mini"
          popper-class="visualization-select-popper"
          clearable
          v-model="angle"
          @change="angleChange"
          placeholder="请选择"
        >
          <el-option
            v-for="item in angleOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="flex items-center mt-10px">
        <span class="text-12px text-white w-60px">地图位置</span>
        <el-select
          popper-class="visualization-select-popper"
          size="mini"
          clearable
          @change="locationChange"
          v-model="location"
          placeholder="请选择"
        >
          <el-option
            v-for="item in locationOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import cloudRender from '../../assets/js/model/index'

export default {
  name: 'smallMap',
  data() {
    return {
      wMap: 280, // 地图宽度
      hMap: 210, // 地图高度
      wParam: 1, // 内容宽度和高度缩放
      angle: '上', // 视角方向
      openMapSwitch: false, // 地图全景图开关
      location: '左上角', // 位置
      angleOptions: ['上', '下', '左', '右'],
      locationOptions: ['左上角', '左下角', '右上角', '右下角'],
    }
  },
  props: {
    isOpenMap: {
      type: Boolean,
      default: false,
    },
    player: {
      type: Object,
    },
    settingEnd: {
      type: Boolean,
    },
  },
  watch: {
    openMapSwitch(val) {
      cloudRender.Setting.set(this.player, { name: 'panorama.show', type: 'bool', value: val })
    },
    settingEnd(val) {
      if (val) {
        this.getSmallMapSettigs()
      }
    },
  },
  methods: {
    async getSmallMapSettigs() {
      // 根据player中的配置设置初始值
      const defaultOpenMapSwitch = await cloudRender.Setting.get(this.player, 'panorama.show')
      this.openMapSwitch =
        defaultOpenMapSwitch && defaultOpenMapSwitch.data
          ? defaultOpenMapSwitch.data[0]?.value
          : false
      const defaultLocation = await cloudRender.Setting.get(this.player, 'map.pos')
      this.location =
        defaultLocation && defaultLocation.data ? defaultLocation.data[0]?.value : '左上角'
      const defaultAngle = await cloudRender.Setting.get(this.player, 'map.dir')
      this.angle = defaultAngle && defaultAngle.data ? defaultAngle.data[0]?.value : '上'
      const defaultWMap = await cloudRender.Setting.get(this.player, 'map.size.x')
      this.wMap = defaultWMap && defaultWMap.data ? defaultWMap.data[0].value : 280
      const defaultHMap = await cloudRender.Setting.get(this.player, 'map.size.y')
      this.hMap = defaultHMap && defaultHMap.data ? defaultHMap.data[0]?.value : 210
      const dedefaultWParam = await cloudRender.Setting.get(this.player, 'map.scale.x')
      this.wParam = dedefaultWParam && dedefaultWParam.data ? dedefaultWParam.data[0]?.value : 1
    },
    closeComponents() {
      this.$emit('closeComponents', 'smallMap')
    },
    locationChange(val) {
      // 设置位置
      cloudRender.Setting.set(this.player, { name: 'map.pos', type: 'stringList', value: val })
    },
    angleChange(val) {
      // 设置方向
      cloudRender.Setting.set(this.player, { name: 'map.dir', type: 'stringList', value: val })
    },
    widthChange(val) {
      // 设置缩放
      cloudRender.Setting.set(this.player, { name: 'map.scale.x', type: 'double', value: val })
      cloudRender.Setting.set(this.player, { name: 'map.scale.y', type: 'double', value: val })
    },
    MapChange(type, val) {
      cloudRender.Setting.set(this.player, {
        name: `map.size.${type}`,
        type: 'int',
        value: val[0],
      })
      // 设置地图大小
    },
  },
}
</script>
<style lang="scss" scoped></style>
